module.exports = __webpack_public_path__ + "img/last.7b12d346.svg";